import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum"
import { projectBasePathName, projectDeletePath } from "@/ts/apiRoutes";

export const useProjectDeleteStore = defineStore('project_delete', () => {
    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    async function deleteProject(id: number) {
        status.value = RequestStatus.LOADING

        const response = await request(`${projectBasePathName}/${id}${projectDeletePath}`, {
            method: 'DELETE'
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS
        }

        return response
    }

    return { status, deleteProject }
})